import styled from 'styled-components';
import { Form } from 'formik';

export const Container = styled.div`
  width: min(calc(100% - 2rem), var(--page-width, 82rem));
  margin: 0 auto;

  @media (max-width: 40rem) {
    width: min(calc(100% - 1rem), var(--page-width, 82rem));
  }
`;

export const FormWrapper = styled.section`
  width: min(calc(100% - 2rem), 72rem);
  position: relative;
  margin: clamp(1rem, 3vw, 2.5rem) auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (max-width: 40rem) {
    width: min(calc(100% - 1rem), 72rem);
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
`;
